import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=65e2b0a3&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=65e2b0a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e2b0a3",
  null
  
)

export default component.exports